/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { I18n } from "@aws-amplify/core";
import AmplifyConfirmSignUp from "aws-amplify-react/lib/Auth/ConfirmSignUp";
import { AuthShell, withInlineAuthError } from "./AuthFormShared";
import { ConfirmSignUpFormView } from "./AuthFormViews";

const ConfirmSignUpBase: any = withInlineAuthError(AmplifyConfirmSignUp);

export class ConfirmSignUp extends ConfirmSignUpBase {
    showComponent() {
        const { hide } = this.props;
        if (hide && hide.includes(ConfirmSignUp)) {
            return null;
        }

        const username = this.usernameFromAuthData();
        const usernameLabel = I18n.get(this.getUsernameLabel());

        return (
            <AuthShell title={I18n.get("Confirm Sign Up")}>
                <ConfirmSignUpFormView
                    error={this.state.authError}
                    onBackToSignIn={() => this.changeState("signIn")}
                    onFieldChange={this.handleInputChange}
                    onResendCode={this.resend}
                    onSubmit={event => {
                        event.preventDefault();
                        this.confirm();
                    }}
                    username={username || undefined}
                    usernameDisabled={Boolean(username)}
                    usernameLabel={usernameLabel}
                />
            </AuthShell>
        );
    }
}

export default ConfirmSignUp;
